import {
    AfterViewInit,
    Component,
    HostListener,
    OnDestroy,
    OnInit,
    ElementRef,
} from "@angular/core";
import { HomePageService } from "../home-page/home-page.service";
import SwiperCore, {
    Thumbs,
    EffectFade,
    Navigation,
    Pagination,
    Scrollbar,
    Swiper,
    Autoplay,
    A11y,
    Keyboard,
} from "swiper";

SwiperCore.use([
    Thumbs,
    EffectFade,
    Scrollbar,
    Navigation,
    Pagination,
    Swiper,
    Autoplay,
    A11y,
    Keyboard,
]);

const SLIDER_A11Y = {
    enabled: true,
    prevSlideMessage: "Poprzedni slajd",
    nextSlideMessage: "Następny slajd",
    paginationBulletMessage: "Przejdź do slajdu {{index}}",
};

@Component({
    selector: "app-home-page-student",
    templateUrl: "./home-page-student.component.html",
    styleUrls: ["./home-page-student.component.scss"],
})
export class HomePageStudentComponent
    implements OnInit, AfterViewInit, OnDestroy
{
    private screenWidth = window.innerWidth;
    private preloadLinks: HTMLLinkElement[] = [];
    galleryLeft: Swiper;
    galleryThumbs: Swiper;

    @HostListener("window:resize", ["$event"])
    onResize(event) {
        this.screenWidth = event.target.innerWidth;
        this.checkWidth();
        this.updateSwipers();
    }

    constructor(
        public homePageService: HomePageService,
        private hostRef: ElementRef<HTMLElement>,
    ) {
        this.homePageService.isHomePage = true;
    }

    ngOnInit() {
        this.checkWidth();
        if (!this.homePageService.isMobileDevice) {
            this.addPreloadLink(
                "./assets/images/vid/30_rps_miejska_dżungla_final_2026.mp4",
                "video",
                "video/mp4",
            );
        }
        if (this.screenWidth < 993) {
            SwiperCore.use([
                Navigation,
                Pagination,
                Scrollbar,
                EffectFade,
                Swiper,
            ]);
        }
    }

    ngAfterViewInit() {
        this.initObbiSlider();
        this.updateSwipers();
    }

    ngOnDestroy() {
        if (this.galleryLeft) {
            this.galleryLeft.destroy(true, true);
        }
        if (this.galleryThumbs) {
            this.galleryThumbs.destroy(true, true);
        }
        this.removePreloadLinks();
    }

    private addPreloadLink(href: string, as: "video" | "image", type?: string) {
        const link = document.createElement("link");
        link.rel = "preload";
        link.as = as;
        link.href = href;
        if (type) {
            link.type = type;
        }
        document.head.appendChild(link);
        this.preloadLinks.push(link);
    }

    private removePreloadLinks() {
        this.preloadLinks.forEach((link) => link.remove());
        this.preloadLinks = [];
    }

    private checkWidth() {
        this.homePageService.isMobileDevice = this.screenWidth < 768;
    }

    private initObbiSlider() {
        this.galleryThumbs = new Swiper(
            "#obbi-slider-wrapper .gallery-thumbs",
            {
                slidesPerView: 4,
                watchSlidesVisibility: true,
                watchSlidesProgress: true,
                direction: "vertical",
                allowTouchMove: false,
            },
        );
        const host = this.hostRef.nativeElement;
        const mainContainer = host.querySelector(
            ".gallery-left",
        ) as HTMLElement;

        if (this.screenWidth < 991) {
            this.galleryLeft = new Swiper(mainContainer, {
                spaceBetween: 16,
                slidesPerView: 1.2,
                slidesOffsetAfter: 24,
                slidesOffsetBefore: 24,
                breakpoints: {
                    991: {
                        slidesPerView: "auto",
                    },
                },
                thumbs: {
                    swiper: this.screenWidth >= 991 ? this.galleryThumbs : null,
                },
                navigation: {
                    nextEl: "#obbi-slider-wrapper .swiper-button-next",
                    prevEl: "#obbi-slider-wrapper .swiper-button-prev",
                },
                pagination: {
                    el: "#obbi-slider-wrapper .swiper-pagination",
                    clickable: true,
                },
                a11y: SLIDER_A11Y,
                keyboard: { enabled: true },
            });
        } else {
            this.galleryLeft = new Swiper(mainContainer, {
                spaceBetween: 16,
                slidesPerView: 1,
                slidesOffsetAfter: 30,
                slidesOffsetBefore: 0,
                breakpoints: {
                    991: {
                        slidesPerView: "auto",
                    },
                },
                thumbs: {
                    swiper: this.screenWidth >= 991 ? this.galleryThumbs : null,
                },
                a11y: SLIDER_A11Y,
                keyboard: { enabled: true },
            });
        }
    }

    goToObbiSlide(index: number) {
        if (this.galleryLeft) {
            this.galleryLeft.slideTo(index);
        }
    }

    private updateSwipers() {
        if (this.galleryLeft) {
            this.galleryLeft.update();
        }
        if (this.galleryThumbs) {
            this.galleryThumbs.update();
        }
    }

    scrollToDescriptionSection() {
        const input = document.getElementById("sectionChalenges");
        if (input !== null) {
            window.scroll({
                top: input.offsetTop,
                behavior: "smooth",
            });
        }
    }
}
